import 'react-alice-carousel/lib/alice-carousel.css';

import {
	dollarFormat,
} from 'helpers/checkoutHelpers';
import { triggerCartEvent } from 'helpers/dataLayerHelpers';
import {
	filter, find,get, map
} from 'lodash';
import moment from 'moment';
import React, { useRef } from 'react';
import AliceCarousel from 'react-alice-carousel';
import { useMediaQuery } from 'react-responsive';

import { OTCMap } from '../../../../content/checkout';
import { StatusTag } from '../styles';
import {
	BetterTogether,
	ContentContainer,
	DualWrapper,
	OTCButton,
	OTCCard,
	OTCImage,
	OTCWrapper,
	PointsWrapper,
	SaveTenWrapper,
	SlideWrapper,
	SpanContainer,
	TitleContainer,
} from './styles';

// custom styling for how many cards should render for react-alice-carousel
const responsive = {
	0: {
		items: 1,
		itemsFit: 'contain',
	},
	150: {
		items: 2,
		itemsFit: 'contain',
	},
	477 : {
		items: 3,
		itemsFit: 'contain',
	},
}

const OutOfCart = ({
	removedProducts,
	addProduct,
	removeProduct,
	cart,
	invoices,
}) => {

	const container = useRef();
	// use isMobile flag to toggle between mobile (also applied to tablet) and desktop styling
	const isMobile = useMediaQuery({ query: '(max-width: 1279px)' });
	// Assign correct component to DetailsWrapper for mobile and desktop styling
	const DetailsWrapper = isMobile ? SpanContainer : PointsWrapper;
	const outOfCartProducts = filter(removedProducts,
		(product) => !cart.products[product.id] && product.quantity_remaining > 0);

	function handleOTCProduct(remove, product) {
		if (remove) {
			removeProduct(product.id);
			logAmplitudeEvent('Click:Checkout_Page',
				{ Checkout_click_name: 'Add_to_cart' })
			if (window) {
				window.scroll({
					top: window.pageYOffset - 175,
					behavior: 'smooth',
				});
			}
		} else {
			addProduct(product.id,
				product.options[0]);
			if (window) {
				window.scroll({
					top: 0,
					behavior: 'smooth',
				} );
			}
		}
		// Handle GA4 event push for either a removal or an add
		triggerCartEvent(product,
			remove);
	}


	const Cards = map(outOfCartProducts,
		(product, key) => {
			const isBodyFormula = product?.descriptor && product?.descriptor.includes('Body');
			const autoRefillDate = get(product,
				'autorefill.payment_date') ? moment.unix(product.autorefill.payment_date)?.format('ddd, MMM D') : false;
			const autoRefill = get(product,
				'options[0].autorefill',
				{});
			// a medication is on hold if there an active auto-refill associated with it and patient has submitted a consultation that is under review.
			const isMedicationOnHold = filter(invoices,
				({
					items, on_hold_date,
				}) => find(items,
					({ rx_type }) => rx_type == product.rx_type && on_hold_date ))?.length > 0
			// screen has custom copy stored in OTCMap, otherwise we can construct product points from existing data attributes.
			const productDetails = OTCMap[product?.otc_type] ||
    [
    	product.medication_type === 'topical' ? `${product.dispense_quantity} grams, 3 mo supply. ` : `${product.options && product.options[0].quantity} ${product.medication_form}, 3 mo supply. `,
    	autoRefillDate && 'Order now to receive your treatment early. ',
    	!autoRefillDate && autoRefill?.discount_cents && `Save ${dollarFormat(autoRefill.discount_cents)} with Auto Refill. Cancel anytime.`,
    ]

			const formatPrice = () => {
				let priceText = '';
				autoRefill && autoRefillDate && autoRefill.price_cents
					? priceText = `${autoRefill.price_cents / 100}`
					: product.options[0].full_price_cents
						? priceText = `${product.options[0].price_cents / 100} ($${product.options[0].full_price_cents / 100} value)`
						: priceText = `${product.options[0].price_cents / 100}`

				return priceText;
			}

			return (
				<div
					key={`${key}_${product.id}`}
					className='carousel-card'
				>
					<DualWrapper>
						<OTCCard>
							<ContentContainer>
								{<OTCImage type={isBodyFormula ? 'body' : product.medication_type}>
									{autoRefillDate && <StatusTag style={{
										position: 'relative',
										top: '10px',
										left: '10px',
									}}>AUTO-REFILL</StatusTag>}
								</OTCImage>}
								<TitleContainer>
									<p>{product.descriptor_short} </p>
								</TitleContainer>
								{autoRefillDate && !isMedicationOnHold && <StatusTag fontSize={10} style={{ padding: '2px 5px' }}>{`SHIPPING ${autoRefillDate}`}</StatusTag>}
								<DetailsWrapper id="points">
									{productDetails && productDetails.map((point, index) => {
										if (point) {
											if(isMobile) {
												return <span key={`${product.id}_${index}`}>{point}</span>
											}
											return <li key={`${product.id}_${index}`}>{point}</li>
										}
									}
									)}
								</DetailsWrapper>
							</ContentContainer>
							<div>
								<OTCButton
									added={cart.products[product.id]}
									onClick={cart.products[product.id] ? () => handleOTCProduct(true,
										product) : () => handleOTCProduct(false,
										product)}
								>
									{cart.products[product.id] ? 'Added' : `Add To Cart $${formatPrice()}`}
								</OTCButton>
							</div>
						</OTCCard>
					</DualWrapper>
				</div>
			)
		});

	return (
		<section role="contentinfo" aria-label='Better Together'>
			<OTCWrapper ref={container}>
				<h3>More from your Treatment Plan</h3>
				<hr/>
				<BetterTogether data-cy={'BetterTogether'}>
					<div>
						<SaveTenWrapper data-cy={'SaveTenWrapper'}>
							<h4>Better Together!</h4>
						</SaveTenWrapper>
						<p>
								When used together, all these treatments are more effective in keeping breakouts under control.
						</p>
					</div>
				</BetterTogether>
				<SlideWrapper length={outOfCartProducts?.length}>
					<AliceCarousel
						items={Cards}
						mouseTracking
						disableButtonsControls
						responsive={responsive}
					/>
				</SlideWrapper>
			</OTCWrapper>
		</section>
	);
};

export default OutOfCart;
